import React, { useState, useEffect, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import StaticDatePicker from '@mui/lab/StaticDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ComFunction from "../components/ComFunction";
import { useSelector } from "react-redux";
import { isEmpty } from '../modules/appLibrary';

//---------------------------------------------------------------------
//  DatePicker
//---------------------------------------------------------------------
export default function DatePicker(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);

    const open = useSelector(state => state.search.datepickeropen);
    const label = useSelector(state =>  state.search.datelabel);
    const datainfo = useSelector(state => state.search.datedata);
    const rowid = useSelector(state => state.search.rowid);
    const doApply = useSelector(state => state.search.datedoApply);
    const gridApi = useSelector(state => state.search.gridApi);
    const [show, setshow] = useState(false)
    const [value, setValue] = React.useState(null);
    const [zindex, setzindex] = useState(10000);

    useEffect(() => {
        setshow(open);
    }, [open])

    useEffect(() => {
        if (!open) return;
        if (isEmpty(rowid)) return;
        if (rowid.length > 1 && !isEmpty(gridApi)) {
            //選択行保持
            for (let i = 0; i < rowid.length; i++) {
                let rowNode = gridApi.getRowNode(rowid[i]);
                rowNode.setSelected(true);
            }
        }
    }, [rowid])

    function Apply(value) {
        // 選択確定後は searchlistclose で datainfo が初期化される。Drawer の閉じ遷移中に
        // もう一度日付をクリックすると初期化後に Apply が届くため、その場合は無視する。
        if (isEmpty(datainfo)) return;
        let data = {
            key: datainfo.columnid,
            value: value,
            rowid: rowid,
            datainfo: datainfo
        };
        doApply(data, 0)
    }

    function onHandleClose() {
        fnc.current.datepickerclose();
    };

    const minYear = datainfo ? Number(datainfo.minYear) : NaN;
    const minDate = Number.isInteger(minYear)
        ? new Date(minYear, 0, 1)
        : undefined;

    return (
        <div>
            <Drawer anchor={"right"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}
                style={{ zIndex: zindex }}
            >
                <div style={{ marginRight: 10 }}>
                    <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 10 }}>
                        <span >{ label}</span>
                    </div>
                </div>
               <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        value={value}
                        minDate={minDate}
                        onChange={(newValue) => {
                            Apply(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
            </Drawer>
            <ComFunc ref={fnc} />
        </div>
    );
};
